import models from '../model/models';

let DrugUtils = function() {
	this.isSupply = (drug) => {
		if (!drug) return false;
		let drug_box = models.drug_box.obj(drug.drug_box_id);
		if (!drug_box) return false;
		let unit = models.unit.obj(drug_box.unit_id);
		if (!unit) return false;
		return unit.type === 'supply';
	};

	this.deployedCount = (drugs, type) => {
		let count = 0;
		for (let i in drugs) {
			let drug = drugs[i];
			if (drug.stock_move_record__quantity <= 0) continue;
			if ((!type || drug.type === type) && !drugUtils.isSupply(drug)) {
				count++;
			}
		}
		return count;
	};

	this.centralCount = (drugs, type) => {
		let count = 0;
		for (let i in drugs) {
			let drug = drugs[i];
			if (drug.stock_move_record__quantity <= 0) continue;
			if ((!type || drug.type === type) && drugUtils.isSupply(drug)) {
				count++;
			}
		}
		return count;
	};

	this.totalCount = (drugs, type) => {
		return this.centralCount(drugs, type) + this.deployedCount(drugs, type);
	};
};

let drugUtils = new DrugUtils();

export default drugUtils;



// WEBPACK FOOTER //
// ./src/utils/drugUtils.js